import React, { memo } from 'react';
import { BodyText, ButtonProps, FlexRow } from '@minecraft.atoms';
import Modal from '@minecraft.modal';
import { useTranslation } from '@blocs.i18n';

export type InstagramDisconnectModalProps = {
  isOpen: boolean;
  close: () => void;
  deleteAllSocialData: () => Promise<void>;
  disconnectSocialAccount: () => Promise<void>;
  loading: boolean;
};

export const InstagramDisconnectModal = memo(
  ({ isOpen, close, deleteAllSocialData, disconnectSocialAccount, loading }: InstagramDisconnectModalProps) => {
    const { t } = useTranslation();

    const buttons: ButtonProps[] = [
      {
        label: t('common:button.cancel'),
        onClick: close,
        variant: 'secondary',
      },
      {
        label: t('talent:profileEdit.social.disconnectModal.button.disconnectAllProfiles'),
        onClick: async () => {
          await deleteAllSocialData();
          close();
        },
        disabled: loading,
      },
      {
        label: t('talent:profileEdit.social.disconnectModal.button.disconnectThisProfile'),
        onClick: async () => {
          await disconnectSocialAccount();
          close();
        },
        disabled: loading,
      },
    ];

    return (
      <Modal
        title={t('talent:profileEdit.social.disconnectModal.title')}
        data-testid="disconnect-modal"
        isOpen={isOpen}
        modalSize="large"
        handleToggleClick={close}
        bodyProps={{ className: 'cn_atom_px-6' }}
        buttons={buttons}
      >
        <FlexRow gap="8">
          <BodyText>{t('talent:profileEdit.social.disconnectModal.headerText')}</BodyText>
          <BodyText>
            <BodyText as="span" fontWeight="semibold">
              {t('talent:profileEdit.social.disconnectModal.disconnectThisProfile.header')}
            </BodyText>
            {t('talent:profileEdit.social.disconnectModal.disconnectThisProfile.description')}
          </BodyText>
          <BodyText>
            <BodyText as="span" fontWeight="semibold">
              {t('talent:profileEdit.social.disconnectModal.disconnectAllProfiles.header')}
            </BodyText>
            {t('talent:profileEdit.social.disconnectModal.disconnectAllProfiles.description')}
          </BodyText>
        </FlexRow>
      </Modal>
    );
  }
);
